'use client';

import React from 'react';
import styles from './CardButton.module.css';

type CardButtonProps = {
  icon: React.ReactNode;
  headline: string;
  paragraph: string;
  ctaLabel: string;
  ctaIcon: React.ReactNode;
  onClick: () => void;
  ctaDestructive?: boolean;
  ctaIconLeft?: boolean;
  disabled?: boolean;
};

const CardButton: React.FC<CardButtonProps> = ({
  icon,
  headline,
  paragraph,
  ctaLabel,
  ctaIcon,
  onClick,
  ctaDestructive,
  ctaIconLeft,
  disabled
}) => {
  // Split headline to add line break after first word
  const headlineWords = headline.split(' ');
  const firstWord = headlineWords[0];
  const restOfHeadline = headlineWords.slice(1).join(' ');

  return (
    <button
      className={`${styles.card} ${disabled ? styles.disabled : ''}`}
      onClick={onClick}
      disabled={disabled}
    >
      <div className={styles.icon}>{icon}</div>
      <h3 className={styles.headline}>
        {firstWord}
        {restOfHeadline && (
          <>
            <br />
            {restOfHeadline}
          </>
        )}
      </h3>
      <p className={styles.paragraph}>{paragraph}</p>
      <div
        className={`${styles.cta} ${ctaDestructive ? styles.destructive : ''}`}
      >
        {ctaIconLeft && ctaIcon}
        <span>{ctaLabel}</span>
        {!ctaIconLeft && ctaIcon}
      </div>
    </button>
  );
};

export default CardButton;